class callout {
    add (title = null, message = null, type = 'success', closable = true, el, prepend = false, scroll = true) {
        let callout = `<div class="callout ${type}">`;

        if (title) {
            callout += `
            <div class="callout-title">
                <svg><use xlink:href="${window.staticURL}/images/sprite.svg#${type}" /></use></svg>
                ${title}
            </div>`;
        }

        if (message) {
            if (typeof message === 'object') {
                message.forEach(line => {
                    callout += `<div class="callout-message">${line}</div>`;
                });
            } else {
                callout += `<div class="${!!title ? 'callout-message' : ''}">${message}</div>`;
            }
        }

        if (closable) {
            callout += `
                    <button class="close-button" aria-label="Dismiss alert" type="button" data-close>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            `;
        } else {
            callout += '</div>';
        }

        const $callout = $(callout);
        $callout.find('.close-button').click(e => {
            $callout.remove();
        });

        if (prepend) {
            $(el).prepend($callout);
        } else {
            $(el).empty().append($callout);
        }

        if (scroll) {
            $('html, body').animate({
                scrollTop: $callout.offset().top - 70
            }, 500);
        }
    }

    primary (title, message, el, closable = true, prepend = false, scroll = true) {
        this.add(title, message, 'primary', closable, el, prepend, scroll);
    }

    success (title, message, el, closable = true, prepend = false, scroll = true) {
        this.add(title, message, 'success', closable, el, prepend, scroll);
    }

    error (title, message, el, closable = true, prepend = false, scroll = true) {
        this.add(title, message, 'alert', closable, el, prepend, scroll);
    }

    warning (title, message, el, closable = true, prepend = false, scroll = true) {
        this.add(title, message, 'warning', closable, el, prepend, scroll);
    }
}

const Callout = new callout();
export default Callout;



// WEBPACK FOOTER //
// ./assets/scripts/components/callout.js